<template>
  <div class="tw-flex tw-justify-between tw-gap-2 tw-py-0.5">
    <WdsText :text="label" secondary sm />
    <slot>
      <WdsText :text="value ?? $t('—')" sm :secondary="value === null" />
    </slot>
  </div>
</template>

<script lang="ts" setup>
import { WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

defineProps<{ label: string; value?: string | null }>()
</script>
